import type { JobListItem } from './types'

export type BranchAdoptionOutcome = 'pending' | 'success' | 'failed'

/** Finished jobs take no Stop and stop their live polls; every other state can be stopped. */
export function isIngestJobFinished(state: string): boolean {
  return state === 'done' || state === 'error' || state === 'skipped' || state === 'cancelled'
}

/** A job query that failed with 404: the job was deleted, so its polls should stop. */
export function isIngestJobNotFoundError(error: unknown): boolean {
  return (
    !!error &&
    typeof error === 'object' &&
    'status' in error &&
    (error as { status?: unknown }).status === 404
  )
}

/**
 * Terminal success per family: done/transformed, or for PLC zip umbrellas
 * only after their child work has settled successfully. Unstructured agent
 * jobs succeed only at `done`.
 */
export function resolveJobBranchAdoptionOutcome(job: JobListItem): BranchAdoptionOutcome {
  const state = job.state as string
  if (state === 'error' || state === 'cancelled') return 'failed'
  if (job.kind === 'plc' && job.fileType === 'zip') {
    const rollup = job.plcGroupRollup
    if (!rollup || rollup.total === 0 || rollup.processing > 0) return 'pending'
    if (rollup.failed > 0 || rollup.cancelled > 0) return 'failed'
    return rollup.complete === rollup.total ? 'success' : 'pending'
  }
  if (job.state === 'done' || job.state === 'transformed') return 'success'
  return 'pending'
}
